module.exports = __webpack_public_path__ + "static/media/after-effects-cc.d618563f.svg";